<template>
  <div>
    <div class="mb-3">
      <label class="form-label">Məhkəmə</label>
      <el-select v-model="local.courtId" placeholder="Seçin" size="large" style="width: 100%;">
        <el-option v-for="court in courts" :key="court.id" :label="court.name" :value="court.id" />
      </el-select>
    </div>
    <div class="mb-3">
      <label class="form-label">Hakim</label>
      <el-input v-model="local.judge" size="large" />
    </div>
    <div class="mb-3">
      <label class="form-label">Məhkəmə icraçısı</label>
      <el-input v-model="local.executor" size="large" />
    </div>
    <div class="mb-3">
      <label class="form-label">Əlaqə nömrəsi (İcraçı)</label>
      <el-input v-model="local.executorPhone" size="large" />
    </div>
    <div class="mb-3">
      <label class="form-label">Tələb olunan məbləğ</label>
      <el-input v-model.number="local.demandedAmount" type="number" size="large" />
    </div>
    <div class="mb-3">
      <label class="form-label">Məhkəməyə qədər xərclər</label>
      <el-input v-model.number="local.preCourtExpense" type="number" size="large" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object, 
    courts: Array
  },
  computed: {
    local: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val); 
      }
    }
  }
};
</script>
